import styled from 'utils/emotion';

export const TextareaStyled = styled('textarea')({
  height: 170,
  resize: 'vertical',
});
